module.exports = __webpack_public_path__ + "img/app-icon-experience.33b15178.png";